// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__BttnK","name":"Header_name__rKhd3","birthday":"Header_birthday__3-Zi2","skeleton":"Header_skeleton__1u_Fm"};